var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "regist mailSetting" }, [
    _c(
      "form",
      {
        ref: "emailSettingForm",
        attrs: { method: "post" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c("input", {
          attrs: { name: _vm.dataCsrfName, type: "hidden" },
          domProps: { value: _vm.dataCsrf },
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { name: "token", type: "hidden" },
          domProps: { value: _vm.dataToken },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.jsonPatchForUserInfo,
              expression: "jsonPatchForUserInfo",
            },
          ],
          attrs: { name: "userinfo_patch", type: "hidden" },
          domProps: { value: _vm.jsonPatchForUserInfo },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.jsonPatchForUserInfo = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("h2", [
          _c("img", { attrs: { src: _vm.emblemImagePath, alt: "" } }),
          _vm._v(
            "\n            " +
              _vm._s(_vm.mailSettingClubTeam.teamName) +
              "からのメール設定\n        "
          ),
        ]),
        _vm._v(" "),
        _vm.isClubTeam
          ? _c("ul", { staticClass: "recieve" }, [
              _c("li", [
                _c(
                  "label",
                  {
                    attrs: { tabindex: "0" },
                    on: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.changeAcceptFlag("acceptFlag")
                      },
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.targetContactCode.acceptFlag,
                          expression: "targetContactCode.acceptFlag",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.targetContactCode.acceptFlag)
                          ? _vm._i(_vm.targetContactCode.acceptFlag, null) > -1
                          : _vm.targetContactCode.acceptFlag,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.targetContactCode.acceptFlag,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.targetContactCode,
                                  "acceptFlag",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.targetContactCode,
                                  "acceptFlag",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.targetContactCode, "acceptFlag", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("i"),
                    _vm._v("クラブからのお知らせ\n                "),
                  ]
                ),
              ]),
            ])
          : _c("ul", { staticClass: "recieve" }, [
              _c("li", [
                _c(
                  "label",
                  {
                    attrs: { tabindex: "0" },
                    on: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.changeAcceptFlag("acceptFlag")
                      },
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.targetContactCode.acceptFlag,
                          expression: "targetContactCode.acceptFlag",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.targetContactCode.acceptFlag)
                          ? _vm._i(_vm.targetContactCode.acceptFlag, null) > -1
                          : _vm.targetContactCode.acceptFlag,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.targetContactCode.acceptFlag,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.targetContactCode,
                                  "acceptFlag",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.targetContactCode,
                                  "acceptFlag",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.targetContactCode, "acceptFlag", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("i"),
                    _vm._v("Ｊリーグからのお知らせ\n                "),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "label",
                  {
                    attrs: { tabindex: "0" },
                    on: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.changeAcceptFlag("storeAcceptFlag")
                      },
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.targetContactCode.storeAcceptFlag,
                          expression: "targetContactCode.storeAcceptFlag",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.targetContactCode.storeAcceptFlag
                        )
                          ? _vm._i(
                              _vm.targetContactCode.storeAcceptFlag,
                              null
                            ) > -1
                          : _vm.targetContactCode.storeAcceptFlag,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.targetContactCode.storeAcceptFlag,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.targetContactCode,
                                  "storeAcceptFlag",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.targetContactCode,
                                  "storeAcceptFlag",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.targetContactCode,
                              "storeAcceptFlag",
                              $$c
                            )
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("i"),
                    _vm._v(
                      "Ｊリーグオンラインストアからのお知らせ\n                "
                    ),
                  ]
                ),
              ]),
            ]),
        _vm._v(" "),
        _c("p", { staticClass: "notice" }, [
          _vm._v(
            "※ 重要なお知らせにつきましては、許諾にかかわらずお届けいたします。"
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btnSpace duo" }, [
          _c(
            "button",
            {
              staticClass: "return",
              attrs: { type: "button" },
              on: { click: _vm.backToHome },
            },
            [_vm._v("メニューに戻る")]
          ),
          _vm._v(" "),
          _c("button", { attrs: { type: "submit" } }, [_vm._v("登録")]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }